import React from 'react';
import { Transition } from 'react-transition-group';
import styled, { useTheme } from 'styled-components';
import SpinnerComponent, { StyledSpinnerView } from './Spinner.component';

interface CardProps extends React.AllHTMLAttributes<HTMLDivElement> {
  isLoading?: boolean;
}

export const StyledCard = styled.div`
  background: ${({ theme }) => theme.colors.CARD};
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  height: max-content;
  word-wrap: break-word;
  position: relative;

  & > ${StyledSpinnerView} {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: ${({ theme }) => theme.colors.CARD};
    border-radius: 8px;
  }
`;

const CardComponent = ({ isLoading = false, children }: CardProps) => {
  const theme = useTheme() as any;

  return (
    <StyledCard>
      {children}
      <Transition
        in={isLoading}
        mountOnEnter
        unmountOnExit
        timeout={{ exit: 300 }}
      >
        {state => (
          <SpinnerComponent
            style={{
              ...theme.animations.reverseDefaultState,
              ...theme.animations.defaultSteps[state],
            }}
          />
        )}
      </Transition>
    </StyledCard>
  );
};

export default CardComponent;
